// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__3So0x","title":"Card_title__2l7Cr","content":"Card_content__26hqn","equalPartition":"Card_equalPartition__Oq_ro"};